module.exports = __webpack_public_path__ + "static/media/filter_empty_mobile.ea8ee13f.svg";